import { IoIosArrowDropup, IoMdInformationCircleOutline } from "react-icons/io"
import { data } from "react-router-dom"

// htmls
const roomMarkersData = [
  {
    // B1
    id: "door-left-a-marker",
    img: 'assets/HotelMerlynn_Thumbnails/mph_residence_livingroom2.jpg',
    icon: IoIosArrowDropup,
    name: "Ballroom Entrance Left - Outside",
    type: "room"
  },
  {
    // B2
    id: "door-left-b-marker",
    img: 'assets/HotelMerlynn_Thumbnails/mph_residence_livingroom2.jpg',
    icon: IoIosArrowDropup,
    name: "Ballroom Entrance Left - Inside",
    type: "room"
  },
  {
    // B15
    id: "door-right-a-marker",
    img: 'assets/HotelMerlynn_Thumbnails/mph_residence_livingroom2.jpg',
    icon: IoIosArrowDropup,
    name: "Ballroom Entrance Right - Outside",
    type: "room"
  },
  {
    // B11
    id: "door-right-b-marker",
    img: 'assets/HotelMerlynn_Thumbnails/mph_residence_livingroom2.jpg',
    icon: IoIosArrowDropup,
    name: "Ballroom Entrance Right - Inside",
    type: "room"
  },
  {
    // B14
    id: "stage-middle-marker",
    img: 'assets/HotelMerlynn_Thumbnails/mph_residence_livingroom2.jpg',
    icon: IoIosArrowDropup,
    name: "Main Stage - Middle",
    type: "room"
  },
  {
    // B4
    id: "stage-front-marker",
    img: 'assets/HotelMerlynn_Thumbnails/mph_residence_livingroom2.jpg',
    icon: IoIosArrowDropup,
    name: "Main Stage - Front",
    type: "room"
  },
  {
    // B12
    id: "stage-operator-marker",
    img: 'assets/HotelMerlynn_Thumbnails/mph_residence_livingroom2.jpg',
    icon: IoIosArrowDropup,
    name: "Stage Operator",
    type: "room"
  },
  {
    // B5
    id: "ballroom-middle-marker",
    img: 'assets/HotelMerlynn_Thumbnails/mph_residence_livingroom2.jpg',
    icon: IoIosArrowDropup,
    name: "Ballroom - Middle",
    type: "room"
  },
  {
    // B10
    id: "ballroom-bottom-right-marker",
    img: 'assets/HotelMerlynn_Thumbnails/mph_residence_livingroom2.jpg',
    icon: IoIosArrowDropup,
    name: "Ballroom - B10",
    type: "room"
  },
  {
    // B7
    id: "ballroom-top-middle-marker",
    img: 'assets/HotelMerlynn_Thumbnails/mph_residence_livingroom2.jpg',
    icon: IoIosArrowDropup,
    name: "Ballroom - B7",
    type: "room"
  },
  {
    // B6
    id: "ballroom-top-left-marker",
    img: 'assets/HotelMerlynn_Thumbnails/mph_residence_livingroom2.jpg',
    icon: IoIosArrowDropup,
    name: "Ballroom - B6",
    type: "room"
  },
  {
    // B8
    id: "ballroom-top-right-marker",
    img: 'assets/HotelMerlynn_Thumbnails/mph_residence_livingroom2.jpg',
    icon: IoIosArrowDropup,
    name: "Ballroom - B8",
    type: "room"
  },
  {
    // B9
    id: "ballroom-middle-right-marker",
    img: 'assets/HotelMerlynn_Thumbnails/mph_residence_livingroom2.jpg',
    icon: IoIosArrowDropup,
    name: "Ballroom - B9",
    type: "room"
  },
  {
    // B3
    id: "ballroom-bottom-left-marker",
    img: 'assets/HotelMerlynn_Thumbnails/mph_residence_livingroom2.jpg',
    icon: IoIosArrowDropup,
    name: "Ballroom - B3",
    type: "room"
  },
]

// htmls
const infoMarkersData = [
  {
    id: "premium-main-bedroom-b-info",
    icon: IoMdInformationCircleOutline,
    name: "Premium Main Bedroom",
    type: "info"
  },
]

const panelContentsData = [
  {
    id: "premium-main-bedroom-b-info-content",
    marker: "premium-main-bedroom-b-info-marker",
    longText: "<p><strong>Premium Main Bedroom:</strong></p> <ul> <li>Built-in wardrobe with mirror doors</li> <li>TV area with entertainment system</li> </ul>",
  },
]

const roomMarkerMapData = [
  {
    id: "door-left-a-marker",
    panorama: "assets/HotelMerlynn_360_4k/B1_Tripodless.jpg",
    markers: [
      {
        id: "door-left-b-marker",
        html: "door-left-b-marker",
        position: { yaw: "80deg", pitch: "0deg" },
        anchor: 'top center',
        data: { type: "room" }
      },
      {
        id: "door-right-a-marker",
        html: "door-right-a-marker",
        position: { yaw: "170deg", pitch: "0deg" },
        anchor: 'top center',
        data: { type: "room" }
      },
    ]
  },
  {
    id: "door-left-b-marker",
    panorama: "assets/HotelMerlynn_360_4k/B2_Tripodless.jpg",
    markers: [
      {
        id: "door-left-a-marker",
        html: "door-left-a-marker",
        position: { yaw: "270deg", pitch: "0deg" },
        anchor: 'top center',
        data: { type: "room" }
      },
      {
        id: "stage-operator-marker",
        html: "stage-operator-marker",
        position: { yaw: "0deg", pitch: "0deg" },
        anchor: 'top center',
        data: { type: "room" }
      },
      {
        id: "ballroom-bottom-left-marker",
        html: "ballroom-bottom-left-marker",
        position: { yaw: "45deg", pitch: "0deg" },
        anchor: 'top center',
        data: { type: "room" }
      },
      {
        id: "door-right-b-marker",
        html: "door-right-b-marker",
        position: { yaw: "180deg", pitch: "0deg" },
        anchor: 'top center',
        data: { type: "room" }
      },
    ]
  },
  {
    id: "stage-operator-marker",
    panorama: "assets/HotelMerlynn_360_4k/B12_Tripodless.jpg",
    markers: [
      {
        id: "ballroom-bottom-left-marker",
        html: "ballroom-bottom-left-marker",
        position: { yaw: "20deg", pitch: "0deg" },
        anchor: 'top center',
        data: { type: "room" }
      },
    ]
  },
  {
    id: "ballroom-bottom-left-marker",
    panorama: "assets/HotelMerlynn_360_4k/B3_Tripodless.jpg",
    markers: [
      {
        id: "door-left-b-marker",
        html: "door-left-b-marker",
        position: { yaw: "75deg", pitch: "0deg" },
        anchor: 'top center',
        data: { type: "room" }
      },
      {
        id: "stage-operator-marker",
        html: "stage-operator-marker",
        position: { yaw: "120deg", pitch: "0deg" },
        anchor: 'top center',
        data: { type: "room" }
      },
      {
        id: "stage-front-marker",
        html: "stage-front-marker",
        position: { yaw: "290deg", pitch: "0deg" },
        anchor: 'top center',
        data: { type: "room" }
      },
    ]
  },
  {
    id: "stage-front-marker",
    panorama: "assets/HotelMerlynn_360_4k/B4_Tripodless.jpg",
    markers: [
      {
        id: "ballroom-bottom-left-marker",
        html: "ballroom-bottom-left-marker",
        position: { yaw: "290deg", pitch: "0deg" },
        anchor: 'top center',
        data: { type: "room" }
      },
      {
        id: "stage-middle-marker",
        html: "stage-middle-marker",
        position: { yaw: "35deg", pitch: "0deg" },
        anchor: 'top center',
        data: { type: "room" }
      },
      {
        id: "ballroom-top-left-marker",
        html: "ballroom-top-left-marker",
        position: { yaw: "120deg", pitch: "0deg" },
        anchor: 'top center',
        data: { type: "room" }
      },
      {
        id: "ballroom-middle-marker",
        html: "ballroom-middle-marker",
        position: { yaw: "215deg", pitch: "0deg" },
        anchor: 'top center',
        data: { type: "room" }
      },
    ]
  },
  {
    id: "stage-middle-marker",
    panorama: "assets/HotelMerlynn_360_4k/B14_Tripodless.jpg",
    markers: [
      {
        id: "stage-front-marker",
        html: "stage-front-marker",
        position: { yaw: "50deg", pitch: "0deg" },
        anchor: 'top center',
        data: { type: "room" }
      },
    ]
  },
  {
    id: "ballroom-top-left-marker",
    panorama: "assets/HotelMerlynn_360_4k/B6_Tripodless.jpg",
    markers: [
      {
        id: "stage-front-marker",
        html: "stage-front-marker",
        position: { yaw: "270deg", pitch: "0deg" },
        anchor: 'top center',
        data: { type: "room" }
      },
      {
        id: "ballroom-top-middle-marker",
        html: "ballroom-top-middle-marker",
        position: { yaw: "180deg", pitch: "0deg" },
        anchor: 'top center',
        data: { type: "room" }
      },
    ]
  },
  {
    id: "ballroom-top-middle-marker",
    panorama: "assets/HotelMerlynn_360_4k/B7_Tripodless.jpg",
    markers: [
      {
        id: "ballroom-middle-marker",
        html: "ballroom-middle-marker",
        position: { yaw: "170deg", pitch: "0deg" },
        anchor: 'top center',
        data: { type: "room" }
      },
      {
        id: "ballroom-top-left-marker",
        html: "ballroom-top-left-marker",
        position: { yaw: "270deg", pitch: "0deg" },
        anchor: 'top center',
        data: { type: "room" }
      },
      {
        id: "ballroom-top-right-marker",
        html: "ballroom-top-right-marker",
        position: { yaw: "90deg", pitch: "0deg" },
        anchor: 'top center',
        data: { type: "room" }
      },
    ]
  },
  {
    id: "ballroom-top-right-marker",
    panorama: "assets/HotelMerlynn_360_4k/B8_Tripodless.jpg",
    markers: [
      {
        id: "ballroom-middle-marker",
        html: "ballroom-middle-marker",
        position: { yaw: "50deg", pitch: "0deg" },
        anchor: 'top center',
        data: { type: "room" }
      },
      {
        id: "ballroom-top-middle-marker",
        html: "ballroom-top-middle-marker",
        position: { yaw: "90deg", pitch: "0deg" },
        anchor: 'top center',
        data: { type: "room" }
      },
      {
        id: "ballroom-middle-right-marker",
        html: "ballroom-middle-right-marker",
        position: { yaw: "0deg", pitch: "0deg" },
        anchor: 'top center',
        data: { type: "room" }
      },
    ]
  },
  {
    id: "ballroom-middle-marker",
    panorama: "assets/HotelMerlynn_360_4k/B5_Tripodless.jpg",
    markers: [
      {
        id: "stage-front-marker",
        html: "stage-front-marker",
        position: { yaw: "285deg", pitch: "0deg" },
        anchor: 'top center',
        data: { type: "room" }
      },
      {
        id: "ballroom-top-left-marker",
        html: "ballroom-top-left-marker",
        position: { yaw: "315deg", pitch: "0deg" },
        anchor: 'top center',
        data: { type: "room" }
      },
      {
        id: "ballroom-top-middle-marker",
        html: "ballroom-top-middle-marker",
        position: { yaw: "12deg", pitch: "0deg" },
        anchor: 'top center',
        data: { type: "room" }
      },
      {
        id: "ballroom-top-right-marker",
        html: "ballroom-top-right-marker",
        position: { yaw: "70deg", pitch: "0deg" },
        anchor: 'top center',
        data: { type: "room" }
      },
      {
        id: "ballroom-middle-right-marker",
        html: "ballroom-middle-right-marker",
        position: { yaw: "102deg", pitch: "0deg" },
        anchor: 'top center',
        data: { type: "room" }
      },
      {
        id: "ballroom-bottom-right-marker",
        html: "ballroom-bottom-right-marker",
        position: { yaw: "135deg", pitch: "0deg" },
        anchor: 'top center',
        data: { type: "room" }
      },
      {
        id: "ballroom-bottom-left-marker",
        html: "ballroom-bottom-left-marker",
        position: { yaw: "250deg", pitch: "0deg" },
        anchor: 'top center',
        data: { type: "room" }
      },
    ]
  },
  {
    id: "ballroom-middle-right-marker",
    panorama: "assets/HotelMerlynn_360_4k/B9_Tripodless.jpg",
    markers: [
      {
        id: "ballroom-middle-marker",
        html: "ballroom-middle-marker",
        position: { yaw: "95deg", pitch: "0deg" },
        anchor: 'top center',
        data: { type: "room" }
      },
      {
        id: "ballroom-top-right-marker",
        html: "ballroom-top-right-marker",
        position: { yaw: "180deg", pitch: "0deg" },
        anchor: 'top center',
        data: { type: "room" }
      },
      {
        id: "ballroom-bottom-right-marker",
        html: "ballroom-bottom-right-marker",
        position: { yaw: "0deg", pitch: "0deg" },
        anchor: 'top center',
        data: { type: "room" }
      },
    ]
  },
  {
    id: "ballroom-bottom-right-marker",
    panorama: "assets/HotelMerlynn_360_4k/B10_Tripodless.jpg",
    markers: [
      {
        id: "ballroom-middle-right-marker",
        html: "ballroom-top-middle-marker",
        position: { yaw: "180deg", pitch: "0deg" },
        anchor: 'top center',
        data: { type: "room" }
      },
      {
        id: "door-right-b-marker",
        html: "door-right-b-marker",
        position: { yaw: "60deg", pitch: "0deg" },
        anchor: 'top center',
        data: { type: "room" }
      },
    ]
  },
  {
    id: "door-right-b-marker",
    panorama: "assets/HotelMerlynn_360_4k/B11_Tripodless.jpg",
    markers: [
      {
        id: "ballroom-bottom-right-marker",
        html: "ballroom-bottom-right-marker",
        position: { yaw: "180deg", pitch: "0deg" },
        anchor: 'top center',
        data: { type: "room" }
      },
      {
        id: "door-right-a-marker",
        html: "door-right-a-marker",
        position: { yaw: "285deg", pitch: "0deg" },
        anchor: 'top center',
        data: { type: "room" }
      },
      {
        id: "door-left-b-marker",
        html: "door-left-b-marker",
        position: { yaw: "15deg", pitch: "0deg" },
        anchor: 'top center',
        data: { type: "room" }
      },
    ]
  },
  {
    id: "door-right-a-marker",
    panorama: "assets/HotelMerlynn_360_4k/B15_Tripodless.jpg",
    markers: [
      {
        id: "door-right-b-marker",
        html: "door-right-b-marker",
        position: { yaw: "7deg", pitch: "0deg" },
        anchor: 'top center',
        data: { type: "room" }
      },
      {
        id: "door-left-a-marker",
        html: "door-left-a-marker",
        position: { yaw: "280deg", pitch: "0deg" },
        anchor: 'top center',
        data: { type: "room" }
      },
    ]
  },
]

const galleryData = [
  {
    id: 'stage-front-marker',
    panorama: 'assets/HotelMerlynn_360_4k/B4_Tripodless.jpg',
    thumbnail: 'assets/HotelMerlynn_Thumbnails/casa_ballroom_stage.png',
    name: 'Stage - Front',
    options: {
      caption: 'Stage - Front',
    },
  },	
  {
    id: 'ballroom-middle-marker',
    panorama: 'assets/HotelMerlynn_360_4k/B5_Tripodless.jpg',
    thumbnail: 'assets/HotelMerlynn_Thumbnails/casa_ballroom_middle.png',
    name: 'Ballroom - Middle',
    options: {
        caption: 'Ballroom - Middle',
    },
  },	
]

const mapData = [
  {
    imageUrl: 'assets/HotelMerlynn_Map/The Residence Map.png',
    center: { x: 595, y: 520 },
    rotation: '30',
    static: 'true',
    coneColor: '#3498db',
    buttons: {
      reset: false,    // hides the reset zoom button
    },
    coneSize: '80',
    defaultZoom: '50',
    minZoom: '50',
    maxZoom: '50',
    hotspots: [
      {
        // I
        id: 'living-room-a',
        x: 1200,
        y: 680,
        color: '#3498db',
        tooltip: 'Living Room - View 1',
      },
    ],
  }
]


export default {
  infoMarkersData,
  roomMarkersData,
  panelContentsData,
  roomMarkerMapData,
  galleryData,
  mapData
}

/***
 * would probably merge info marker with room marker as custom marker
 * their difference were just animation and the info marker don't have image
 * 
 * we use html to make custom marker but it has to be a string. so we use React
 * renderToStaticMarkup function to render React component to HTML string. 
 * But creating the marker dynamically probably needs a.. helper?
 * mainly to do the renderToString function for every marker and then pair the marker
 * to associated room. This pairing is practically a database structure haha  
 * 
 * anyway..
 * 
 * don't forget a break in switch case function
 * don't forget arrow function with {} must explicitly use return keyword as {} means a function body
 * 
 */